<script lang="ts">
    import type { JitsiSettings } from "./jitsi";
    import JitsiVideo from "./JitsiVideo.svelte";
    import { setState, setSupervisorPresent, state } from "./stores";

    export let jitsi: JitsiSettings;

    const handleJoin = async (api: JitsiMeetExternalAPI) => {
        api.executeCommand("toggleLobby", true);
        api.executeCommand("subject", "Vanhempainvartti");
        try {
            await setSupervisorPresent();
        } catch (e) {
            api.executeCommand("hangup");
        }
    };

    const handleLeave = async (__: JitsiMeetExternalAPI) => {
        setState("OPEN");
    };

    const supervisorSettings = {
        ...jitsi,
        options: {
            ...jitsi.options,
            toolbarButtons: [
                "fullscreen",
                "hangup",
                "participants-pane",
                "video",
                "microphone",
                "chat",
                "toggle-camera",
                "select-background",
                "tileview",
            ],
            remoteVideoMenu: {
                disabled: false,
                disableKick: false,
            },
        },
    };
</script>

{#if $state === "CLOSED"}
    <button on:click={() => setState("OPEN")}>Avaa Vanhempainvartti</button>
{/if}
{#if $state === "OPEN" || $state === "SUPERVISOR_PRESENT"}
    <button on:click={() => setState("CHAT_IS_OVER")}
        >Lopeta tämänkertainen Vanhempainvartti</button
    >
{/if}
{#if $state === "CHAT_IS_OVER"}
    <p>
        <button on:click={() => setState("OPEN")}
            >Jatka Vanhempainvarttia</button
        >
    </p>
    <p>
        <button on:click={() => setState("CLOSED")}
            >Sulje Vanhempainvartti</button
        >
    </p>
{/if}

{#if $state === "OPEN" || $state === "SUPERVISOR_PRESENT"}
    <div class="video">
        <JitsiVideo
            jitsi={supervisorSettings}
            on:join={(e) => handleJoin(e.detail.api)}
            on:leave={(e) => handleLeave(e.detail.api)}
        />
    </div>
{/if}

<style>
    .video {
        margin-top: 16px;
    }
</style>
